export const signalTypes = {
    SPAN: 'span',
    MEASUREMENT: 'measurement',
    LOG: 'log',
    EXCEPTION: 'exception',
    EVENT: 'event',
    UNKNOWN: 'unknown'
};
export const ALLOWED_ATTRIBUTE_SUFFIXES = ['_duration_ms', '_count', '_timestamp', '_bytes', '_meta'];
